import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Seo from '../components/Seo';

const BlogDetails = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const res = await axios.get(`https://toporion.net/blogs/${slug}`);
                if (res.data.success) {
                    setPost(res.data.data);
                }
            } catch (error) {
                console.error("API_ERROR:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchPost();
    }, [slug]);

    if (loading) return <div className="min-h-screen bg-[#0f172a] flex items-center justify-center font-mono text-[#00F0FF]">LOADING_PROTOCOL...</div>;
    if (!post) return <div className="min-h-screen bg-[#0f172a] flex items-center justify-center text-white font-mono">404: NOT_FOUND</div>;

    // FIX FOR BOTH PROBLEMS - Clean ALL bad URLs
    const cleanContent = post.content
        ?.replace(/\/blog\/www\./g, 'https://www.')
        .replace(/\/blog\/http:/g, 'http:')
        .replace(/http:\/\/localhost:3000/g, '')
        .replace(/\/blog\/https:/g, 'https:')
        .replace(/https:\/\/toporion.net\/blog\/https:/g, 'https:')
        .replace(/\/blog\/\/\//g, '/')
        .replace(/\/blog\/(www\.)/g, 'https://$1');

    return (
        <>
            <Seo 
                title={`${post.title} | Top Orion`}
                description={post.description}
                keywords={post.keywords}
                featuredImage={post.featuredImage}
            />

            <div className="min-h-screen bg-[#0f172a] text-white pt-24 pb-24">
                <div className="container mx-auto px-6 max-w-4xl">
                    <header className="mb-12">
                        <div className="flex items-center gap-4 text-[#00F0FF] font-mono text-[10px] mb-6 uppercase tracking-widest">
                            <span>// {new Date(post.createdAt).toLocaleDateString()}</span>
                            <span className="w-1.5 h-1.5 bg-white/10 rounded-full"></span>
                            <span>BY {post.author?.toUpperCase() || "SALMAN HAIDER"}</span>
                        </div>
                        <h1 className="text-4xl md:text-6xl font-black mb-8 leading-tight">{post.title}</h1>
                        <img 
                            src={post.featuredImage} 
                            alt={post.title} 
                            className="w-full rounded-3xl border border-white/10 shadow-2xl" 
                        />
                    </header>

                    <main 
                        className="prose prose-invert prose-cyan max-w-none text-gray-300 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: cleanContent }} 
                    />
                </div>
            </div>
        </>
    );
};

export default BlogDetails;